// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JNY9","importantInfo":"styles_importantInfo__3p_vD"};